export const getFFPageDemoMembers = (t) => [
  {
    uid: 'aaa',
    name: t('ff.demo-member-1'),
    rolesActions: [],
    followerCount: 1,
    followingCount: 1,
    picture: '//static.wixstatic.com/media/1bf8c6_3a91e06d5ecc42c78288a53b93c1c58d~mv2.jpg',
    isSubscribed: true,
  },
  {
    uid: 'bbb',
    name: t('ff.demo-member-2'),
    rolesActions: [],
    followerCount: 0,
    followingCount: 1,
    picture: '//static.wixstatic.com/media/1bf8c6_f86530516f48403e8ed26e56b3aed926~mv2.jpg',
  },
  {
    uid: 'ccc',
    name: t('ff.demo-member-3'),
    rolesActions: [],
    followerCount: 0,
    followingCount: 1,
    picture: '//static.wixstatic.com/media/1bf8c6_0c4c38632b9b4f45b9cc669541730588~mv2.jpg',
  },
];
